import { z } from "zod/v4";

export const tickEventSchema = z.object({
  gameId: z.string(),
  time: z.number(),
});

export const socketEventMessageSchema = z.object({
  eventType: z.string(),
  event: z.looseObject({ id: z.string() }),
});

export type TickEvent = z.infer<typeof tickEventSchema>;
export type SocketEventMessage = z.infer<typeof socketEventMessageSchema>;
